import { CSSProperties, memo } from 'react';
import { Tag } from 'antd';
import { ProductCondition, productConditionOptions } from 'models/auction/Auction';

interface AuctionTitleProps {
  condition: ProductCondition;
  style?: CSSProperties;
}

function AuctionTitle({ condition, style }: AuctionTitleProps) {
  const conditionColor: { [key in ProductCondition]: string } = {
    new: '#00ff00',
    used: '#808080',
    refurbished: '#0099cc',
    other: '#ffa500',
  };

  return (
    <Tag style={style} color={conditionColor[condition]}>
      {productConditionOptions.filter(({ value }) => value === condition)[0].label}
    </Tag>
  );
}

export default memo(AuctionTitle);
